<div
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  class="content flexible-column-centered"
  *transloco="let t"
>
  <ng-container *ngIf="loading; else loaded">
    <app-circular-progress-indicator
      class="flexible center-flexible"
    ></app-circular-progress-indicator>
  </ng-container>

  <ng-template #loaded>
    <ng-container *ngIf="error; else content">
      <app-error-message class="flexible center-flexible"></app-error-message>
    </ng-container>

    <ng-template #content>
      <ng-container *ngIf="favorites.length == 0">
        <div class="description-container flexible-column-centered">
          <p
            class="description"
            [ngClass]="{
              'text-7': !isMobile,
              'text-7-small': isSmall,
              'text-7-xsmall': isXSmall
            }"
          >
            {{ t("products.products_favorites.description_popup") }}
          </p>
        </div>

        <button
          class="button fill-width"
          [ngClass]="{
            'button-3': !isMobile,
            'button-3-small': isSmall,
            'button-3-xsmall': isXSmall
          }"
          mat-stroked-button
          (click)="onClickButtonEmpty()"
        >
          {{ t("products.products_favorites.button") }}
        </button>
      </ng-container>

      <ng-container *ngIf="favorites.length > 0">
        <p
          [innerHTML]="
            (favorites.length == 1 ? 'shared.popup_menu.favorites.quantity_1' : 'shared.popup_menu.favorites.quantity') | transloco : { quantity: favorites.length }
          "
          class="title"
          [ngClass]="{
            'text-7': !isMobile,
            'text-7-small': isSmall,
            'text-7-xsmall': isXSmall
          }"
        ></p>

        <div class="list fill-width">
          <app-popup-menu-product-item
            *ngFor="let item of favorites"
            [item]="item"
            (onProductSelected)="productSelected($event)"
          ></app-popup-menu-product-item>
        </div>

        <button
          class="fill-width"
          [ngClass]="{
            'button-2': !isMobile,
            'button-2-small': isSmall,
            'button-2-xsmall': isXSmall
          }"
          (click)="onClickButton()"
          mat-stroked-button
        >
          {{ t("shared.popup_menu.favorites.button") }}
        </button>
      </ng-container>
    </ng-template>
  </ng-template>
</div>
